<template>
  <div>
    <div class="left-container">
      <categroy-list @selected="selected" />
    </div>
    <div class="right-container">
      <navigation-list :category-id="categoryId" />
    </div>
  </div>
</template>

<script>
import CategroyList from '@/pages/system/navigation/CategroyList';
import NavigationList from '@/pages/system/navigation/NavigationList';

export default {
  components: {
    CategroyList,
    NavigationList
  },
  data() {
    return {
      categoryId: null
    };
  },
  methods: {
    selected(value) {
      this.categoryId = value;
    }
  }
};
</script>
<style lang="less" scoped>
.left-container {
  width: 300px;
  float: left;
  margin-right: 16px;
}
.right-container {
  width: calc(~'100% - 316px');
  float: left;
}
</style>
